const isInViewport = (element) => {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

const shuffleText = (element, duration = 1000) => {
	const originalText = element.textContent;
	const characters = "0123456789";
	let shuffleInterval;

	let currentDuration = 0;
	const stepTime = 50;

	const maskText = (text) => {
		return text.replace(/\d/g, () =>
			characters[Math.floor(Math.random() * characters.length)]
		);
	};

	shuffleInterval = setInterval(() => {
		element.textContent = maskText(originalText);
		currentDuration += stepTime;

		if (currentDuration >= duration) {
			clearInterval(shuffleInterval);
			element.textContent = originalText;
		}
	}, stepTime);
};

const activateShuffleOnVisible = (selector, sectionSelector, duration = 1000) => {
	const sections = document.querySelectorAll(sectionSelector);
	const elements = document.querySelectorAll(selector);

	console.log(sections);

	if (sections.length && elements.length) {
		const observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						elements.forEach((element) => shuffleText(element, duration));
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.5 }
		);

		sections.forEach((section) => {
			observer.observe(section);
		});
	}
};